import { useEffect, useState } from 'react';
import { Keyboard, Platform } from 'react-native';
export function useKeyboardVisible() {
    const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
    useEffect(() => {
        const showEvent = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
        const hideEvent = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';
        const showListener = Keyboard.addListener(showEvent, () => {
            setIsKeyboardVisible(true);
        });
        const hideListener = Keyboard.addListener(hideEvent, () => {
            setIsKeyboardVisible(false);
        });
        return () => {
            showListener.remove();
            hideListener.remove();
        };
    }, []);
    return isKeyboardVisible;
}
